export const SYNC_NARRATIVE_FOLDER_IDENTIFIER = "narrativeFolder";
